import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";

const COLORS = ["#6366f1", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899", "#f97316"];

export default function PieChartWidget({ data, tagKey = "provider", fullscreen }) {
    const pieData = buildPieData(data, tagKey);

    if (pieData.length === 0) {
        return <div className="empty-chart">No data</div>;
    }

    return (
        <ResponsiveContainer width="100%" height={fullscreen ? "100%" : 220}>
            <PieChart isAnimationActive={false}>
                <Pie
                    data={pieData}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={80}
                    paddingAngle={2}
                    dataKey="value"
                    nameKey="name" isAnimationActive={false}
                >
                    {pieData.map((_, i) => (
                        <Cell key={i} fill={COLORS[i % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip formatter={(v) => Number(v).toLocaleString()} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
            </PieChart>
        </ResponsiveContainer>
    );
}

function buildPieData(data, tagKey) {
    if (!data || data.length === 0) return [];

    const grouped = new Map();
    for (const point of data) {
        const tagValue = point.tags?.[tagKey] || point[tagKey] || "Other";
        grouped.set(tagValue, point.value ?? point.v ?? 0);
    }

    return Array.from(grouped.entries()).map(([name, value]) => ({
        name,
        value,
    }));
}
